import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useMantineTheme, NavLink, Box } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { useLoginContext } from "../context/loginContext";

import { defaultTab, getPropInSubLevelRole, safetyDecodeJWT } from "../utils/globalFunctions";

const MenuList = ({ stateMenuList, stateMenu, fnClickMenu }) => {

    const navigate = useNavigate();
    const { subMenu } = useParams();
    const theme = useMantineTheme();
    const matchesMinSM = useMediaQuery(`(min-width: ${theme.breakpoints.sm})`);

    const { loginContext } = useLoginContext();

    return (
        <Box>
            {stateMenuList && Object.keys(stateMenuList).length > 0 && Object.keys(stateMenuList).map((keyHeader, indexHeader) => {
                return (
                    stateMenuList[keyHeader].isShow && <NavLink
                        key={keyHeader}
                        label={`${stateMenuList[keyHeader].menuCaptionLong}`}
                        icon={stateMenuList[keyHeader].menuIcon}
                        childrenOffset={28}

                        defaultOpened
                        mb={`${matchesMinSM ? '.25rem' : 'xs'}`}

                        sx={{
                            borderRadius: theme.radius.sm,
                            fontWeight: '500'
                        }}
                    >
                        {Object.keys(stateMenuList[keyHeader].subMenu).map((keySubmenu, indexSubMenu) => {
                            return (
                                <NavLink
                                    key={keySubmenu}
                                    label={stateMenuList[keyHeader].subMenu[keySubmenu].name}
                                    // icon={stateMenuList[keyHeader].subMenu[keySubmenu].icon}
                                    mb={`${matchesMinSM ? '.25rem' : 'xs'}`}
                                    active={stateMenuList[keyHeader].subMenu[keySubmenu].flag === subMenu}

                                    sx={{
                                        borderRadius: theme.radius.sm,
                                    }}

                                    onClick={() => {
                                        fnClickMenu();
                                        navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateMenuList[keyHeader].slug}/${stateMenuList[keyHeader].subMenu[keySubmenu].flag}/${defaultTab(stateMenuList[keyHeader].subMenu[keySubmenu])}`, { replace: true })
                                    }}
                                />
                            )
                        })}
                    </NavLink>
                )
            })}
        </Box>
    )
}

export default MenuList;